module.exports = __webpack_public_path__ + "static/media/12.91c8bb54.png";